import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { WebSocketSubject } from 'rxjs/webSocket';

import {
  RemoteDiagnosticsFailureResponseData,
  RemoteDiagnosticsResponse,
  RemoteDiagnosticsStatus,
  RemoteDiagnosticsSuccessResponseData,
} from './remote-diagnostics.model';

import { MockedVdd } from './mocked-vdds/MockedVdd.model';
import * as Vdds from './mocked-vdds/index';

export interface VddSimulator {
  id: string;
  subscription: Subscription;
  authToken?: string;
}

@Injectable()
export class RemoteDiagnosticsHelpersService {
  cancelRequests$: Subject<void> = new Subject<void>();
  subject: WebSocketSubject<any> = new Subject<any>() as WebSocketSubject<any>;

  makeId(parts?: number[]): string {
    parts = parts ?? [8, 4, 4, 4, 12];
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    let result = '';
    parts.forEach((lengthPart) => {
      for (let i = 0; i < lengthPart; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      result += '-';
    });

    return result.slice(0, -1);
  }

  makeUrlWebsocketPart(): string {
    const serverId = Math.floor(Math.random() * 900 + 100);
    const sessionIdLength = 8;
    const sessionId = this.makeId([sessionIdLength]);

    return serverId + '/' + sessionId;
  }

  getDate(): string {
    return new Date().toISOString().replace('T', ' ').replace('Z', '');
  }

  makeWebsocketFormat(value: Object): string[] {
    let resultString = '';
    const mainKey = Object.keys(value)[0];
    resultString += mainKey + '\n';

    const optionalKeys = Object.keys(value[mainKey]);
    optionalKeys.forEach((key) => {
      resultString += key + ':' + value[mainKey][key] + '\n';
    });

    resultString += '\n' + '\u0000';

    return [resultString];
  }

  getMockedDataReadRunningValue(
    requestId: string,
    _value: number,
    vdd: string = 'OutsideTemperatureSensor',
    cycle: number,
    index: number,
    logicalLink: string = 'LL_0002_HMU_CAN01'
  ): RemoteDiagnosticsResponse<RemoteDiagnosticsSuccessResponseData> {
    const response: RemoteDiagnosticsResponse<RemoteDiagnosticsSuccessResponseData> = {
      requestId,
      status: RemoteDiagnosticsStatus.RUNNING,
      date: this.getDate(),
      data: (new Vdds[vdd]() as MockedVdd).readSingleSync(logicalLink),
      vdd,
      logicalLink,
      cycle,
      type: 'com.ApiFunctionsOnlineQueries.ReadVddDataByVdd_Single',
      index,
    };

    return response;
  }

  getMockedDataReadSuccessValue(
    requestId: string,
    _value: number,
    vdd: string,
    cycle: number,
    index: number,
    logicalLink: string = 'LL_0002_HMU_CAN01'
  ): RemoteDiagnosticsResponse<RemoteDiagnosticsSuccessResponseData> {
    const response: RemoteDiagnosticsResponse<RemoteDiagnosticsSuccessResponseData> = {
      requestId,
      status: RemoteDiagnosticsStatus.ENDED,
      date: this.getDate(),
      data: (new Vdds[vdd]() as MockedVdd).readSingleSync(logicalLink),
      vdd,
      logicalLink,
      cycle,
      type: 'com.ApiFunctionsOnlineQueries.ReadVddDataByVdd_Single',
      index,
    };

    return response;
  }

  getMockedDataReadFailureValue(
    requestId: string,
    cycle: number,
    index: number
  ): RemoteDiagnosticsResponse<RemoteDiagnosticsFailureResponseData> {
    const response: RemoteDiagnosticsResponse<RemoteDiagnosticsFailureResponseData> = {
      requestId,
      status: RemoteDiagnosticsStatus.FAILURE,
      date: this.getDate(),
      data: {
        FailureCause:
          'Execution failed: com.kpit.otx.common.value.values.core.exception.OtxOutOfBoundsException: Index: 0, Size: 0Index: 0, Size: 0',
      },
      vdd: null,
      logicalLink: null,
      cycle,
      type: 'com.ApiFunctionsOnlineQueries.ReadVddDataByVdd_Single',
      index,
    };

    return response;
  }
}
